import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Assigns and unassigns Vehicle Groups to Vehicles
 * @param id The ID of the Vehicle the Vehicle Groups are being assigned to
 * @param assignmentVehicleGroupIds The Vehicle Groups being assigned
 * @param unassignmentVehicleGroupIds The Vehicle Groups being unassigned
 * @returns Data object containing the newly assigned Vehicle Groups
 */
export function postVehiclesVehicleGroupsCombinedAssignment(
  this: unknown,
  id: number,
  assignmentVehicleGroupIds: number[],
  unassignmentVehicleGroupIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .vehiclesVehicleGroupsCombinedAssignmentUrl(id),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            assignmentVehicleGroupIds,
            unassignmentVehicleGroupIds,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.object({
          assigned: z.array(z.number()),
          unassigned: z.array(z.number()),
        }),
      })
    )
  );
}
